import { useEffect, useState } from "react";

export const useKeyPress = (condition: boolean, targetKey: string) => {
  const [keyPressed, setKeyPressed] = useState(false);

  useEffect(() => {
    const downHandler = (event: KeyboardEvent) => {
      if (event.key === targetKey) {
        setKeyPressed(true);
        event.stopPropagation();
        event.preventDefault();
      }
    };

    const upHandler = (event: KeyboardEvent) => {
      if (event.key === targetKey) setKeyPressed(false);
    };

    if (condition) {
      window.addEventListener("keydown", downHandler);
      window.addEventListener("keyup", upHandler);
    }

    return () => {
      window.removeEventListener("keydown", downHandler);
      window.removeEventListener("keyup", upHandler);
    };
  }, [targetKey, condition]);

  return keyPressed;
};
